import { theme } from '@traba/theme'
import { SvgIconProps } from '@traba/types'

export const Car = ({
  size = 16,
  color = theme.colors.Violet,
  strokeWidth = 1.5,
  ...rest
}: SvgIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#carClip)">
        <path
          d="M3.83333 11.3334H2.5C2.05556 11.3334 1.5 10.9334 1.5 9.33335C1.5 7.33335 3.16667 2.66669 7.83333 2.66669C12.5 2.66669 10.5 7.00002 13.1667 7.00002C15.1667 7.00002 15.2778 10.2222 15.1667 11.3334H12.5M3.83333 11.3334C3.83333 10.3334 4.5 9.66669 5.5 9.66669C6.5 9.66669 7.16667 10.3334 7.16667 11.3334M3.83333 11.3334C3.83333 12.3334 4.5 13 5.5 13C6.5 13 7.16667 12.3334 7.16667 11.3334M7.16667 11.3334H9.16667M9.16667 11.3334C9.16667 10.3334 9.83333 9.66669 10.8333 9.66669C11.8333 9.66669 12.5 10.3334 12.5 11.3334M9.16667 11.3334C9.16667 12.3334 9.83333 13 10.8333 13C11.8333 13 12.5 12.3334 12.5 11.3334"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="carClip">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
